<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>

        <SearchPostalCodeComponent :dialog="$store.getters.searchDialog"/>
        <CompleteStatementDialogModal :finalMessage="finalMessage"/>
        <InformationExchange/>
        <VouchersDialog :vouchers="vouchersForDialog"/>

        <v-alert :value="util.isNPlus2OrKatataktirios() || !$store.getters.checkedDegree" class="rounded-alert mx-3 " icon="error" type="error">
            <small>Βάσει της νομοθεσίας δεν δικαιούστε δωρεάν διανομής συγγραμμάτων εφόσον είστε άνω των ν+2 ετών φοίτησης ή παρακολουθείτε μαθήματα για τη λήψη τρίτου ή ανωτέρου πτυχίου προπτυχιακών σπουδών.
                Έχετε τη δυνατότητα να αποκτήσετε συγγράμματα μόνο μέσω της Ανταλλαγής Συγγραμμάτων (Eudoxus+).</small>
        </v-alert>

        <div class="text-xs-center pt-2">
            <h2>Στοιχεία Παραλαβής Συγγραμμάτων</h2>
            <hr/>
        </div>


        <v-container grid-list-xl>
            <v-layout row justify-space-between  wrap>
                <v-flex md2>

                        <v-btn  color="info darken-2" round to="/statementBookList">
                            <v-icon>arrow_back_ios</v-icon>
                            <span>Περίληψη Επιλογών</span>
                        </v-btn>

                </v-flex>
                <v-flex md2>
                    <v-btn :disabled="!$store.getters.newStatementAllow" @click="createListSemesterData"
                            color="primary lighten-1"
                           round>
                        <v-icon>edit</v-icon>&nbsp;&nbsp;
                        <span>Τροποποίηση Δήλωσης</span>
                    </v-btn>
                </v-flex>
                <v-flex md2 v-if="($store.getters.pinFlag || !$store.getters.newStatementAllow) && (!util.isNPlus2OrKatataktirios() || $store.getters.checkedDegree
                               || $store.getters.booksFromRedeemByDistPoint.length > 0) && !$store.getters.studentAddressInformation">
                    <v-btn @click="getPIN()" color="light-blue lighten-1 white--text" round>
                        <v-icon>fiber_pin</v-icon>&nbsp;&nbsp;
                        <span>Υπενθύμιση PIN</span>
                    </v-btn>
                </v-flex>

                <v-flex md2>
                    <v-tooltip bottom>
                        <v-btn :color="changeColorInFinalDeclarationButton()? 'blue-grey lighten-1 white--text' : 'green darken-1 white--text'" :disabled=!showFinalDeclarationButton() @click="toggleCompleteDialog"
                                round slot="activator">
                            <v-icon>done_all</v-icon>&nbsp;&nbsp;
                            <span>Τελική Υποβολή</span>
                        </v-btn>
                        <span>Πατήστε "Τελική Υποβολή Δήλωσης" για να υποβάλετε τη δήλωσή σας,<br/>
                   μόνο εάν είστε βέβαιος/η ότι παρακολουθείτε νομίμως όλα τα αντίστοιχα μαθήματα. <br/>
                   Σε περίπτωση ψευδούς δηλώσεως φέρετε πλήρη ευθύνη για τις συνέπειες.<br/>
                   Μετά την υποβολή της δήλωσης, μπορείτε να δηλώσετε ποια συγγράμματα <br/>
                   επιθυμείτε να παραλάβετε από άλλον φοιτητή, μέσω αυτής της οθόνης.</span>
                    </v-tooltip>
                </v-flex>





                <!--<v-flex>-->
                    <!--<v-layout align-end column>-->
                        <!--<v-tooltip bottom>-->
                            <!--<v-btn :disabled=!showFinalDeclarationButton() @click="toggleCompleteDialog" class="right"-->
                                   <!--color="info" round slot="activator">-->
                                <!--<v-icon>done_all</v-icon>&nbsp;&nbsp;-->
                                <!--<span>Τελική Υποβολή</span>-->
                            <!--</v-btn>-->
                            <!--<span>Πατήστε "Τελική Υποβολή Δήλωσης" για να υποβάλετε τη δήλωσή σας,<br/>-->
                   <!--μόνο εάν είστε βέβαιος/η ότι παρακολουθείτε νομίμως όλα τα αντίστοιχα μαθήματα. <br/>-->
                   <!--Σε περίπτωση ψευδούς δηλώσεως φέρετε πλήρη ευθύνη για τις συνέπειες.<br/>-->
                   <!--Μετά την υποβολή της δήλωσης, μπορείτε να δηλώσετε ποια συγγράμματα <br/>-->
                   <!--επιθυμείτε να παραλάβετε από άλλον φοιτητή, μέσω αυτής της οθόνης.</span>-->
                        <!--</v-tooltip>-->
                        <!--<v-btn @click="getPIN()" color="info" round-->
                               <!--v-if="($store.getters.pinFlag || !$store.getters.newStatementAllow) && (!util.isNPlus2OrKatataktirios() || $store.getters.checkedDegree-->
                               <!--|| $store.getters.booksFromRedeemByDistPoint.length > 0)">-->
                            <!--<v-icon>fiber_pin</v-icon>&nbsp;&nbsp;-->
                            <!--<span>Υπενθύμιση PIN</span>-->
                        <!--</v-btn>-->
                    <!--</v-layout>-->
                <!--</v-flex>-->
            </v-layout>
        </v-container>

        <v-flex class="mx-2" xs12 v-if="!$store.getters.newStatementAllow">

            <v-alert
                    dismissible
                    color="light-blue lighten-1 white--text"
                    v-model="showPin">
                Ο αριθμός PIN με τον οποίο μπορείτε να παραλάβετε τα συγγράματα σας είναι {{PIN}}. Θα λάβετε
                υπενθύμιση και μέσω email.
            </v-alert>

            <ReviewStatementBooksComponent/>
        </v-flex>


        <v-flex class="mx-2" xs12 v-else>
            <v-alert
                    dismissible
                    color="light-blue lighten-1 white--text"
                    v-model="showPin">
                Ο αριθμός PIN με τον οποίο μπορείτε να παραλάβετε τα συγγράματα σας είναι {{PIN}}. Θα λάβετε
                υπενθύμιση και μέσω email.
            </v-alert>

            <v-alert class="caption"
                     type="error"
                     v-model="showCourierAlert">
                Παρακαλώ επιλέξτε σταθμό courier που επιθυμείτε να παραλάβετε βιβλία πριν υποβάλετε τη δήλωσή σας.
                Η αποστολή με courier θα γίνει στο σταθμό της επιλογής σας για βιβλία που δεν διανέμονται από σημεία διανομής.
                Το κόστος της ταχυμεταφοράς επιβαρύνει μόνο τους εκδότες και όχι τους φοιτητές.
            </v-alert>

            <DeclarationStatementBooks/>
        </v-flex>

        <v-layout align-start column justify-center v-if="$store.getters.courierInfoFlag">
            <CourierInfoComponent/>
        </v-layout>
        <v-layout align-start column justify-center v-if="$store.getters.studentAddressInformation">
            <AddressInfoComponent/>
        </v-layout>
        <v-flex class="offset-xs0 " >
            <v-btn v-if="showCourierButton()" :color="!showFinalDeclarationButton()? 'error' : 'info'" @click="openSearchDialog" class="my-3" round
                   small>{{courierButtonMessage()}}
            </v-btn>
            <v-btn color="primary" @click="openVouchersDialog" class="my-3" round outline
                   small>Εμφάνιση Vouchers
            </v-btn>
        </v-flex>
    </v-container>
</template>

<script>
    import DistributionPointComponent from "../ExtraComponents/DistributionPoinComponent"
    import CourierInfoComponent from "../ExtraComponents/CourierInfoComponent"
    import ExchangeTypeComponent from "../ExtraComponents/ExchangeTypeComponent";
    import InformationExchange from "../ExtraComponents/InformationExchange";
    import SearchPostalCodeComponent from "../ExtraComponents/SearchPostalCodeComponent";
    import requests from "../../requests";
    import CompleteStatementDialogModal from "../ExtraComponents/CompleteStatementDialogModal";
    import util from "../../utilities";
    import ToolTipComponent from "../ExtraComponents/ToolTipComponent";
    import FinalSubmitCheckedComponent from "./FinalSubmitCheckedComponent";
    import FinalSubmitRedeemComponent from "./FinalSubmitRedeemComponent";
    import ReviewStatementBooksComponent from "./ReviewStatementBooksComponent";
    import DeclarationStatementBooks from "./DeclarationStatementBooksComponent";
    import AddressInfoComponent from "./AddressInfoComponent";
    import VouchersDialog from "../ExtraComponents/VouchersDialog";


    export default {
        name: "StatementReceiptInfo",
        components: {
	        VouchersDialog,
            AddressInfoComponent,
            DeclarationStatementBooks,
            ReviewStatementBooksComponent,
            FinalSubmitRedeemComponent,
            FinalSubmitCheckedComponent,
            ToolTipComponent,
            CompleteStatementDialogModal,
            SearchPostalCodeComponent,
            InformationExchange,
            ExchangeTypeComponent, DistributionPointComponent, CourierInfoComponent
        },
        data() {
            return {
                finalMessage: '',
                util,
                value: true,
                finalDeclarationflag: false,
                showPin: false,
                vouchersForDialog:'',
            }
        },
        methods: {

	        openVouchersDialog(){
		        let vouchers = '';
		        this.$store.getters.booksFromCheckedByCourrier.forEach( (obj) =>{
			        let statementBook = obj.book.books.books[0].book;

			        if(statementBook.hasOwnProperty('voucherNo') && statementBook.voucherNo !== null){
				        vouchers += statementBook.voucherNo + ','
			        }
		        });
		        this.$store.getters.booksFromRedeemByCourrier.forEach( (obj) =>{
			        let statementBook = obj.book.books.books[0].book;

			        if(statementBook.hasOwnProperty('voucherNo') && statementBook.voucherNo !== null){
				        vouchers += statementBook.voucherNo + ','
			        }
		        });
		        if(vouchers.length>0){
			        vouchers = vouchers.slice(0, -1);// remove last comma
		        }
		        this.vouchersForDialog = vouchers;
	        	this.$store.commit('setVouchersDialog', true);
            },

            //change the color of the declaration button
            changeColorInFinalDeclarationButton() {

                var active = this.$store.getters.active;
                //if active .bookgroups is not empty return #43A047 else #78909C
                if (active.bookGroups.length > 0) {
                    return false
                }

                return true
            },

            courierButtonMessage() {
                if (!this.showFinalDeclarationButton()) {
                    return 'Επιλογή Σταθμού Courier'
                }
                else {
                    return 'Αλλαγή Σταθμού Courier'
                }
            },
            getPIN(){
                this.$store.commit('setLoadingModal', true);
                var statementId = this.$store.getters.statementComplete.id;
                requests.getPIN(statementId, this.successGetPIN);
            },
            successGetPIN(response) {
                this.$store.commit('setLoadingModal', false);
                this.showPin = true
            },
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },
            closeDialog() {
                this.$store.commit('setDialog', false)
            },
            createBookSelect(response) {
                var statementBookId;
                var exchangeSourceId;
                var bookSelect = {};
                for (var i = 0; i < response.bookGroups.length; i++) {
                    statementBookId = response.bookGroups[i].books[0].book.statementBookId;
                    if (response.bookGroups[i].books[0].book.hasOwnProperty('exchangeSourceId')) {
                        exchangeSourceId = response.bookGroups[i].books[0].book.exchangeSourceId;
                        bookSelect[response.bookGroups[i].books[0].id.bookId] = {statementBookId: statementBookId, exchangeSourceId: exchangeSourceId};
                    }
                    else {
                        bookSelect[response.bookGroups[i].books[0].id.bookId] = {statementBookId: statementBookId};
                    }
                }
                this.$store.commit('setBookSelect', bookSelect);
            },
            CallBackSuccessFinalDeclaration(response) {
                this.$store.commit('setStatementComplete', response);
                this.$store.commit('setStatementIsComplete', true);
                this.createBookSelect(response);
                requests.statement(this.loginCallBackSuccessStatement);
                requests.active(this.loginCallBackSuccessActive);
            },
            toggleCompleteDialog() {

                var webservicestatus  = this.$store.getters.login.academic.webservicestatus;
                var coursesCodes = [];
                var checkedBooks = this.$store.getters.checkedBooks;

                for (var checkedBook in checkedBooks) {
                    coursesCodes.push(checkedBook)
                }


                if (webservicestatus && coursesCodes.length > 0) {
                    this.$store.commit('setLoadingModal', true);
                    requests.checkCourceRegistration(coursesCodes, this.successCheckCourceRegistration)
                }
                else {
                    this.finalDeclaration();
                }
            },

            finalDeclaration() {

                var active = util.createStatementBookGroup();

                this.$store.commit('setStatementBookGroup', active);
                this.$store.commit('setLoadingModal', true);
                requests.finalDeclaration(active, this.CallBackSuccessFinalDeclaration);
            },

            successCheckCourceRegistration(response){

                this.$store.commit('setCourseRegistration' , response);
                var countCourses = 0;
                var message = {};
                message.warningTitle = 'Προσοχή!';
                message.warningMessage = ' Έχετε επιλέξει συγγράμματα για μαθήματα τα οποία δεν έχετε δηλώσει στη Γραμματεία της Σχολής σας. Τα παρακάτω μαθήματα θα πρέπει είτε να τα δηλώσετε στη Γραμματεία σας είτε να τα αποεπιλέξετε για να συνεχίσετε';
                // message.message += '<v-tooltipleft><template v-slot:activator="{ on }"><v-icon class="right" color="red" v-on="on">warning</v-icon></template><span>Δεν δικαιούστε το σύγγραμμα</span></v-tooltip>';
                message.close = true;
                if (response.length > 0 ){
                    message.warningList = '';
                    response.forEach(function (el) {
                        if (!el.registrationFound) {
                            if(el.courseDTO.code){
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ '[' + el.courseDTO.code +']'  + ' '+ el.courseDTO.title +'</v-list-item-title></v-list-item-content></v-list-item>'
                            }else{
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ el.courseDTO.title +  '</v-list-item-title></v-list-item-content></v-list-item>'
                            }
                            countCourses++;
                        }
                    });
                }
                if (countCourses > 0) {
                    this.enableWarnings();
                    this.$store.commit('setMessageObject', message);
                    this.$store.commit('setMessageModal', true);
                }
                else {
                    this.finalDeclaration();
                    return;
                }
                this.$store.commit('setLoadingModal', false);
            },

            enableWarnings() {

                var courseRegistration =  this.$store.getters.courseRegistration;
                var semesterData = this.$store.getters.semesterData;

                courseRegistration.forEach(function (reg) {
                    var semester = reg.courseDTO.semester;
                    if (!reg.registrationFound) {
                        semesterData.forEach(function (sem) {
                            if (sem.semester == semester) {
                                sem.courseRegistration = true;
                                sem.semesterInfo.forEach(function (semInfo) {
                                    if (semInfo.courseIno.id == reg.courseDTO.id) {
                                        semInfo.courseRegistration = true
                                    }
                                })
                            }
                        })
                    }
                });
                this.$store.commit('setSemesterData', semesterData);
            },

            loginCallBackSuccessStatement(response) {

                if (response.hasOwnProperty('statementAddress')) {
                    this.$store.commit('setStudentAddressInformation', true);
                    this.$store.commit('setStatementAddress', response.statementAddress);
                }
                else {
                    this.$store.commit('setStudentAddressInformation', false);
                    this.$store.commit('setStatementAddress', {});
                }

                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setCompleteDialog', true);
                this.$store.commit('setPinFlag', true);
                if (response.data.length) {
                    this.$store.commit('setStatement', response.data);
                    if (response.data[0].hasOwnProperty("courrierId")) {
                        let urlEncode = encodeURI(response.data[0].courrierId);
                        requests.courier(urlEncode, this.loginCallBackSuccessCourier);
                    }
                }
            },
            loginCallBackSuccessCourier(response) {
                this.$store.commit('setCourier', response);
            },
            loginCallBackSuccessActive(response) {
                var active = this.$store.getters.active;
                var login =  this.$store.getters.login;

                if (login.inArrangementsBlackListByStatement === false ) {
                    if (active.inArrangementsBlackList === true) {
                        login.inArrangementsBlackListByStatement = true;
                        this.$store.commit('setLogin', login)
                    }
                    else {
                        login.inArrangementsBlackListByStatement = false;
                        this.$store.commit('setLogin', login)
                    }
                }

                this.finalMessage = '';
                if (response.bookGroups.length < 1) {
                    this.$store.commit('setActiveDeclaration', true);
                    this.$store.commit('setNewStatementAllow', true);
                }
                if (util.isNPlus2OrKatataktirios()){
                    var hasCreditBookGroups = !response.hasOwnProperty('hasCreditBookGroups') ? false : response.hasCreditBookGroups;
                    if (!hasCreditBookGroups) {
                        this.finalMessage = 'Η Δήλωση αποθηκεύτηκε επιτυχώς.Βάσει της νομοθεσίας δεν δικαιούστε δωρεάν διανομής συγγραμμάτων εφόσον είστε άνω των ν+2 ετών φοίτησης ή παρακολουθείτε μαθήματα για τη λήψη τρίτου ή ανωτέρου πτυχίου προπτυχιακών σπουδών. Έχετε τη δυνατότητα να αποκτήσετε συγγράμματα μόνο μέσω της Ανταλλαγής Συγγραμμάτων.';
                    }
                    else {
                        this.finalMessage = 'Η Δήλωση αποθηκεύτηκε επιτυχώς.Μπορείτε να παραλάβετε τα συγγράμματα που δηλώσατε για εξαργύρωση με τον αριθμό PIN '+ this.$store.getters.statementComplete.pin +' . Τα υπόλοιπα συγγράμματα μπορείτε να τα αποκτήσετε μόνο μέσω της Ανταλλαγής Συγγραμμάτων.'
                    }
                }
                else {
                    this.finalMessage = 'Η Δήλωση αποθηκεύτηκε επιτυχώς. Μπορείτε να παραλάβετε τα συγγράμματά σας από τα σημεία διανομής με τον αριθμό PIN '+ this.$store.getters.statementComplete.pin +', ο οποίος θα σας αποσταλεί και μέσω e-mail. Αν επιθυμείτε να παραλάβετε συγγράμματα από άλλο φοιτητή, μπορείτε να το δηλώσετε πατώντας "Επιλογή παραλαβής από φοιτητή".'
                }

                this.$store.commit('setActive', response);
            },
            openSearchDialog() {
                this.$store.commit('setSearchDialog', true)
            },
            showCourierButton() {
                return this.$store.getters.courierInfoFlag && this.$store.getters.newStatementAllow
            },
            showFinalDeclarationButton() {

                return !!(this.$store.getters.finalDeclarationflag &&
                    this.$store.getters.newStatementAllow && this.$store.getters.active.hasAcceptedTerms);
            },
            checkToolTipId(bookId) {
                var toolTipId = this.$store.getters.tooltipBookId;
                return toolTipId.hasOwnProperty(bookId);
            },
            createListSemesterData() {
                var semesterArray = this.$store.getters.semesters;
                this.semesterCoursesArray = [];
                const courses = this.$store.getters.courses;
                for (let i = 0; i < semesterArray.length; i++) {
                    var semesterCourses = [];
                    var semester = semesterArray[i];

                    for (let j = 0; j < courses.length; j++) {
                        let courseItem = courses[j];
                        if (courseItem.semester === semester)
                            semesterCourses.push(courseItem);
                    }

                    this.semesterCoursesArray.push({semester: semester, courses: semesterCourses});
                }
                this.finalCoursesData()

            },

            // ToDo move to Utilities
            finalCoursesData() {

                const books = this.$store.getters.listOfBooksById;
                let semesterData = [];

                for (let i = 0; i < this.semesterCoursesArray.length; i++) {

                    var courseObject = [];
                    let courses = this.semesterCoursesArray[i].courses;
                    for (let j = 0; j < courses.length; j++) {

                        let courseBooks = [];
                        let courseInfo;
                        let bookExistsInChecked = false;
                        let bookId = null;

                        for (let z = 0; z < books.length; z++) {
                            if (books[z].courseId == courses[j].id && books[z].active === true) {
                            	if(books[z]['statementBookGroupType'] == null ){
		                            books[z]['statementBookGroupType'] = 'NORMAL';
                                }
                                courseInfo = books[z].course;
                                courseBooks.push(books[z]);

                                if (this.$store.getters.checkedBooks[books[z].courseId] !== undefined) {
                                    bookId = this.$store.getters.checkedBooks[books[z].courseId].books.books[0].book.id;
                                    bookExistsInChecked = true;
                                }
                            }
                        }

                        if (courseInfo == null) {
                            courseInfo = courses[j];
                        }

                        courseObject.push({
                            courseIno: courseInfo,
                            courseBooks: courseBooks.sort((bookA, bookB) => (bookA.position < bookB.position) ? -1 : 1),
                            visibilityFlag: bookExistsInChecked,
                            radioValue: bookId,
                            courseRegistration: false
                        });
                    }
                    semesterData.push({semester: this.semesterCoursesArray[i].semester, semesterInfo: courseObject, courseRegistration: false});
                }

                this.$store.commit('setSemesterData', semesterData);
                this.$router.push({path: '/newStudentBookList'});
            }
        },
        computed: {
            PIN: function () {
                return this.$store.getters.statementComplete.pin
            },
            showCourierAlert: function () {
                return !!(this.$store.getters.newStatementAllow && this.$store.getters.courierInfoFlag && Object.keys(this.$store.getters.courier).length == 0);
            }
        },
        created() {
            this.showCourierButton();
            this.showFinalDeclarationButton();
        }

    }
</script>

<style scoped>

</style>
